module.exports = __webpack_public_path__ + "media/PAG66-07.de5ece85.mp3";